/**
 * Right now, this should only be shown to users who are on the free plan.
 */
import Backbone from "backbone";
import $ from "jquery";
import * as preact from "preact";
import * as _ from "underscore";

import * as deviceDetect from "deviceDetect";
import * as localAPI from "localAPI";
import * as modalDialog from "modalDialog";
import readlangClient from "readlangClient";
import * as subscriptionPlans from "shared/subscriptionPlans";
import * as upsellTimer from "upsellTimer";

const isBookmarklet = window.location.pathname === "/bookmarklet";

const AccountPanelView = Backbone.View.extend({
  initialize: function (options) {
    this.options = _.defaults(options, {
      showTitle: true,
    });
    upsellTimer.reset();
    this.render();
  },
  render: async function () {
    this.$el.empty();

    const user = this.model.toJSON();
    const localMode = await localAPI.isLocalMode();

    let extraPhrases = false;
    let phraseLimit: undefined | number = undefined;

    if (this.options.phraseLimit) {
      const acheivements = this.model.get("acheivements") || [];
      if (acheivements.indexOf("extraPhrases") === -1) {
        // DISABLE extra phrases
        extraPhrases = true;
      }
      phraseLimit =
        user.phraseLimit || subscriptionPlans.permissions.free.phrases;
    }

    // const allPhrasesLimit = this.options.allPhrasesLimit ? true : false;

    /** Show Premium Plus instead of Premium */
    const plus = this.options.plus;

    if (localMode) {
      preact.render(
        <div>
          <h2>Premium {plus ? "Plus" : ""} Plan</h2>
          <ul>
            <li>${plus ? 15 : 6} / month</li>
            <li>
              ${plus ? 120 : 48} / year{" "}
              <small>
                <i>(only ${plus ? 10 : 4} / month)</i>
              </small>
            </li>
          </ul>
          <a href="#" class="signupLink">
            Sign in
          </a>{" "}
          to try the free version first.
        </div>,
        this.$el[0]
      );
      return;
    }

    const freePlan = (
      <div class="plan2">
        <h4>
          Free Limited <span class="currentPlan">(Current plan)</span>
        </h4>
        <div class="price">$0</div>
        <table>
          <tr>
            <td>
              <div class="checkmark"></div>
            </td>
            <td>
              Unlimited <span class="highlight">single word</span> translations
            </td>
          </tr>
          <tr>
            <td>
              <div class="checkmark"></div>
            </td>
            <td>
              <strong>10</strong> phrase translations per day
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              <span class="subtle">
                (<strong>6</strong> words per phrase)
              </span>
            </td>
          </tr>
          <tr>
            <td>
              <div class="checkmark"></div>
            </td>
            <td>
              <strong>10</strong> context explanations per day
            </td>
          </tr>
          <tr class="notIncluded">
            <td>
              <div class="cross"></div>
            </td>
            <td>Written conversation practice</td>
          </tr>
          <tr class="notIncluded">
            <td>
              <div class="cross"></div>
            </td>
            <td>Audio upload and transcription</td>
          </tr>
          <tr class="notIncluded">
            <td>
              <div class="cross"></div>
            </td>
            <td>Generate stories with the Story Bot</td>
          </tr>
          <tr class="notIncluded">
            <td>
              <div class="cross"></div>
            </td>
            <td>Context-aware translations</td>
          </tr>
          <tr class="notIncluded noMobile">
            <td>
              <div class="cross"></div>
            </td>
            <td>Practice or export flashcards from specific books</td>
          </tr>
          <tr class="notIncluded noMobile">
            <td>
              <div class="cross"></div>
            </td>
            <td>0 streak repairs</td>
          </tr>
        </table>

        {phraseLimit && extraPhrases ? (
          <>
            <h5>1 time only freebie:</h5>
            <a class="secondaryLink extraPhrases" href="#">
              Get {phraseLimit} more phrase translations
            </a>
          </>
        ) : null}
      </div>
    );
    const premiumPlan = (
      mode: "current" | "new" | "upgrade",
      plusPlan: boolean
    ) => (
      <div class="plan2 suggested">
        <h4>
          Premium {plusPlan ? "Plus" : ""}{" "}
          {mode === "current"
            ? "(Current Plan)"
            : plusPlan
              ? ""
              : "plans starting from..."}
        </h4>
        <span class="currentPlanPlaceholder">&nbsp;</span>
        <div class="price">
          ${plusPlan ? 10 : 4}
          <small> /mo</small>
        </div>
        <table>
          <tr>
            <td>
              <div class="checkmark"></div>
            </td>
            <td>
              <strong>Unlimited</strong> single word translations
            </td>
          </tr>
          <tr>
            <td>
              <div class="checkmark"></div>
            </td>
            <td>
              <strong>Unlimited</strong> phrase translations
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              <span class="subtle">
                (<strong>12</strong> words per phrase)
              </span>
            </td>
          </tr>
          <tr>
            <td>
              <div class="checkmark"></div>
            </td>
            <td>
              <strong>Unlimited</strong> context explanations
            </td>
          </tr>
          <tr>
            <td>
              <div class="checkmark"></div>
            </td>
            <td>
              <strong>Written conversation</strong> practice
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              <span class="subtle">
                {plusPlan ? (
                  <>
                    (<strong>Unlimited</strong>)
                  </>
                ) : (
                  <>
                    (<strong>2</strong> per day)
                  </>
                )}
              </span>
            </td>
          </tr>
          <tr>
            <td>
              <div class="checkmark"></div>
            </td>
            <td>
              <strong>Audio upload</strong> and transcription
            </td>
          </tr>
          <tr>
            <td>
              <div class="checkmark"></div>
            </td>
            <td>
              <strong>Generate stories</strong> with the Story Bot
            </td>
          </tr>
          <tr>
            <td>
              <div class="checkmark"></div>
            </td>
            <td>
              <strong>Context-aware</strong> translations
            </td>
          </tr>
          <tr class="noMobile">
            <td>
              <div class="checkmark"></div>
            </td>
            <td>Practice or export flashcards from specific books</td>
          </tr>
          <tr class="noMobile">
            <td>
              <div class="checkmark"></div>
            </td>
            <td>
              <strong>2</strong> streak repairs per month
            </td>
          </tr>
          {plusPlan ? (
            <tr>
              <td>
                <div class="checkmark"></div>
              </td>
              <td>
                <strong>Better AI</strong> for AI powered features
              </td>
            </tr>
          ) : null}
        </table>

        {mode === "current" ? null : (
          <>
            <div class="cancelAnytime">Cancel anytime</div>
            {mode === "new" ? (
              <a class="goToCheckout" href="/checkout">
                See premium plans
              </a>
            ) : (
              <a class="goToCheckout" href="/account">
                Upgrade
              </a>
            )}
          </>
        )}
      </div>
    );

    const hasPremium =
      user.subscriptionPlan === "standard" ||
      user.subscriptionPlan === "freeForever";

    const currentPlan = hasPremium ? premiumPlan("current", false) : freePlan;

    const suggestedPlan = premiumPlan(hasPremium ? "upgrade" : "new", plus);

    preact.render(
      <div class="accountPanel2">
        {this.options.showTitle && (
          <h2 class="spacing" style={{ textAlign: "center" }}>
            Go Premium
          </h2>
        )}

        <div class="planContainer2">
          {deviceDetect.isSmall() ? (
            <>
              {suggestedPlan}
              {currentPlan}
            </>
          ) : (
            <>
              {currentPlan}
              {suggestedPlan}
            </>
          )}
        </div>
      </div>,

      this.$el[0]
    );
  },
  events: {
    "click .goToCheckout": "goToCheckout",
    "click .loginLink": "loginLink",
    "click .signupLink": "signupLink",
    "click .extraPhrases": "extraPhrases",
    "click .continue": "continue",
  },
  goToCheckout: function (event) {
    if (isBookmarklet) {
      event.preventDefault();
      event.stopPropagation();

      // Ensure the checkout page loads in a new tab, because otherwise it'll appear awkwardly
      // within the iframe
      const protocol =
        window.location.hostname === "localhost" ? "http://" : "https://";
      window.top.location.href = protocol + window.location.host + "/checkout";
      return;
    }
  },
  loginLink: function (event) {
    event.preventDefault();
    event.stopPropagation();
    $("#loginButton").click();
  },
  signupLink: function (event) {
    event.preventDefault();
    event.stopPropagation();
    $("#signUpButton").click();
  },
  extraPhrases: function (event) {
    event.preventDefault();
    event.stopPropagation();
    this.$el
      .find(".extraPhrases")
      .after($('<img src="/content/throbber.gif"></img>'));
    this.$el.find(".extraPhrases").hide();
    readlangClient.request("POST", "/api/user/claimExtraPhrases", {}, () => {
      const acheivements = this.model.get("acheivements") || [];
      if (acheivements.indexOf("extraPhrases") === -1) {
        acheivements.push("extraPhrases");
      }
      this.model.set("acheivements", acheivements);
      modalDialog.cancel();
    });
  },
  continue: function () {
    modalDialog.cancel();
  },
});

export default AccountPanelView;
